var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C3.55556 0.5 0 4.05556 0 8.5C0 12.9444 3.55556 16.5 8 16.5C12.4444 16.5 16 12.9444 16 8.5C16 4.05556 12.4444 0.5 8 0.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5629 12.0483C11.2152 12.3959 10.6521 12.3965 10.3041 12.0485L8.00006 9.74444L5.696 12.0485C5.34846 12.396 4.79054 12.4016 4.43721 12.0483L4.45179 12.0628C4.10412 11.7152 4.10354 11.1521 4.45155 10.8041L6.75561 8.5L4.45155 6.19594C4.10401 5.8484 4.09846 5.29048 4.45179 4.93715L4.43721 4.95173C4.78488 4.60406 5.34798 4.60348 5.696 4.95149L8.00006 7.25555L10.3041 4.95149C10.6517 4.60395 11.2096 4.5984 11.5629 4.95173L11.5483 4.93715C11.896 5.28482 11.8966 5.84792 11.5486 6.19594L9.2445 8.5L11.5486 10.8041C11.8961 11.1516 11.9017 11.7095 11.5483 12.0628L11.5629 12.0483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.65fdb0a99b65cb2f7c6f41b708e5f8de.svg";
export { ForwardRef as ReactComponent };